import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/web/app/materials/MaterialsIndexClient.tsx");
